import { DraftEmailAttachment } from "client/Api/Email/respondToEmail";

export type InsertAttachmentsToExchangeEmailRequestModel<T> = {
	attachments: readonly T[];
	draft: MailMessageLocationModel;
};

export type MailMessageLocationModel = {
	smtpAddress: OptionalModel<string>;
	messageId: string;
};

export type MailMessageLocationQueryModel = {
	smtpAddress: string | null;
	messageId: string;
};

export enum InsertAttachmentFromDmsResult {
	Ok = 0,
	InsertFolderDoNotSupported = 1,
	DoNotEnoughPermissions = 2,
	AttachmentsTooBig = 3
}

export type EmailAttachmentResultModel = {
	state: InsertAttachmentFromDmsResult;
	name: string;
	attachment: DraftEmailAttachment;
};

export interface ExchangeEmailId {
	id: string;
	hasValue?: boolean;
}

export enum EmailImportance {
	Low = -1,
	Normal = 0,
	High = 1
}

export interface ExchangeFolderId {
	id: string;
}

export interface ExchangeEmailManagementErrorModel {
	message: string;
}

export const enum SignatureKind {
	None = 0,
	Personal = 1,
	Managed = 2
}

export enum ExchangeMessageBodyKind {
	Text = 1,
	Html = 2
}